import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms"
import { ModalService } from "../../services/modal.service"
import { ModalComponent } from "./modal.interface"
import { Component, Inject, ViewChild, ElementRef, AfterViewInit } from "@angular/core"
import { ApiService } from "../../services/api.service"
import { TranslateService } from "../../services/translate.service"
import { AuthService } from "../../services/auth.service"
import { DialogButtonComponent } from "../buttons/dialog-button.component"
import { CommonModule } from "@angular/common"
import {phoneValidator} from '../../utils/phone_validator';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DialogButtonComponent,
    CommonModule,
  ],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-lg w-80">
      <div class="p-6" [formGroup]="phoneForm">
        <h2 class="text-xl font-bold mb-4">{{ getString('Swishbetalning') }}</h2>

        <input
          #phoneInput
          type="tel"
          formControlName="phone"
          [placeholder]="getString('073 225811')"
          class="mt-4 p-2 w-full border rounded focus:outline-none bg-theme-surface2 focus:ring-2 focus:ring-primary"
        />
        <div *ngIf="phoneControl.invalid && phoneControl.touched" class="text-theme-warning mt-2">
          <div *ngIf="phoneControl.hasError('required')">
            {{ getString('Telefonnummer krävs') }}
          </div>
          <div *ngIf="phoneControl.hasError('invalidPhone')">
            {{ getString('Ogiltigt telefonnummer') }}
          </div>
        </div>

        <div class="mt-4" *ngIf="!data.isKiosk">
          <label class="inline-flex items-center">
            <input type="checkbox" formControlName="savePhone" class="mr-2" />
            {{ getString('Spara nummer') }}
          </label>
        </div>

        <div class="mt-4 flex justify-end gap-2">
          <app-dialog-button
            [text]="getString('Stäng')"
            (onClick)="close()">
          </app-dialog-button>
          <app-dialog-button
            [text]="getString('Betala')"
            [disabled]="!isValid() || isWorking"
            (onClick)="onSend()"
            variant="primary">
          </app-dialog-button>
        </div>

        <div *ngIf="isWorking" class="mt-4 text-theme-text3">
          {{ getString("Bearbetar...") }}
        </div>
        <div *ngIf="errorMsg" class="mt-4 text-theme-warning">
          {{ errorMsg }}
        </div>
      </div>
    </div>
  `
})
export class SwishNumberDialogComponent implements ModalComponent, AfterViewInit {
  @ViewChild('phoneInput') phoneInput!: ElementRef;
  phoneForm: FormGroup;
  isWorking = false;
  errorMsg?: string;
  modalData?: any;
  private sendFunc: (phone: string, savePhone: boolean) => void;

  constructor(
    private modalService: ModalService,
    public api: ApiService,
    private translate: TranslateService,
    private auth: AuthService,
    @Inject('MODAL_DATA') public data: {
      isKiosk: boolean;
      phone?: string;
      sendFunction: (phone: string, savePhone: boolean) => void;
    }
  ) {
    const initialPhone = data.isKiosk ? '' : (data.phone || '');
    const initialSavePhone = !data.isKiosk && data.phone !== undefined;
    this.sendFunc = data.sendFunction;

    this.phoneForm = new FormGroup({
      phone: new FormControl(initialPhone, {
        nonNullable: true,
        validators: [
          Validators.required,
          phoneValidator()
        ]
      }),
      savePhone: new FormControl(initialSavePhone)
    }, {
      updateOn: 'change'
    });
  }

  ngAfterViewInit() {
    setTimeout(() => this.phoneInput?.nativeElement?.focus());
  }

  get phoneControl() {
    return this.phoneForm.controls["phone"]!;
  }

  getString(s: string) {
    return this.translate.single(s);
  }

  isValid(): boolean {
    return !this.phoneControl.hasError('required') && !this.phoneControl.hasError('invalidPhone');
  }

  close() {
    this.modalService.close();
  }

  onSend() {
    if (!this.isValid()) {
      return;
    }

    this.sendFunc(this.phoneControl.value, this.phoneForm.controls["savePhone"]!.value);
  }
}
